import { gql } from "@apollo/client";

export const AUTORIZAR_RECHAZO_MASIVO = gql`
mutation UpdateEstadoAutorizacionControl(
  $idsAutorizacionControl: [Int!]!
  $idEstado: Int!
  $observacion: String!
) {
  updateEstadoAutorizacionControl(
    idsAutorizacionControl: $idsAutorizacionControl
    idEstado: $idEstado
    observacion: $observacion
  ) {
    success
  }
}`;